import { ChangeDetectionStrategy, Component, ViewEncapsulation, computed, input } from '@angular/core';

export type FvElevatedPadding = 'none' | 'sm' | 'md' | 'lg';
export type FvElevatedElevation = 'none' | 'l1' | 'l2' | 'l3' | 'l4';
export type FvElevatedRadius = 'none' | 'sm' | 'md' | 'lg';

/**
 * FvElevatedComponent — elevated surface primitive (background + shadow + radius + padding).
 *
 * Wraps arbitrary content in an elevated panel. Defaults match the Figma "Card/Mapping"
 * spec: neutral-primary background, L3 shadow, 8px radius, 24px padding.
 */
@Component({
  selector: 'fv-elevated',
  standalone: true,
  template: '<ng-content />',
  styleUrl: './elevated.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[class]': 'hostClasses()' },
})
export class FvElevatedComponent {
  readonly padding = input<FvElevatedPadding>('lg');
  readonly elevation = input<FvElevatedElevation>('l3');
  readonly radius = input<FvElevatedRadius>('sm');

  readonly hostClasses = computed(
    () =>
      `fv-elevated fv-elevated--padding-${this.padding()} fv-elevated--elevation-${this.elevation()} fv-elevated--radius-${this.radius()}`
  );
}
